import { useMutation } from '@tanstack/react-query';
import { leagueFetch } from '@leagueplatform/league-fetch';
import { getUserProfile } from '@leagueplatform/user-profile-api';

export const useDeleteAccountMutation = () =>
  useMutation<boolean, Error, void>({
    mutationKey: ['deleteAccount'],
    mutationFn: async () => {
      const userProfileResponse = await getUserProfile();

      if (!userProfileResponse?.user_id) {
        throw new Error('unable to get user_id.');
      }

      const response = await leagueFetch(
        `/v1/users/${userProfileResponse.user_id}`,
        { method: 'DELETE' },
      );

      if (!response.ok) {
        throw new Error(`${response.status}`);
      }

      return true;
    },
  });
